import React from 'react';

const VenueTagList = ({ venues, onRemove }) => (
  <div className="mt-2 flex flex-wrap gap-1">
    {venues.map(venue => (
      <div
        key={venue}
        className="flex items-center bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded border border-blue-300"
      >
        {venue}
        <button
          onClick={() => onRemove(venue)}
          className="ml-1 text-blue-600 hover:text-blue-800 focus:outline-none touch-target text-sm"
          aria-label={`Remove ${venue}`}
        >
          &times;
        </button>
      </div>
    ))}
  </div>
);

export default VenueTagList;
